/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name topbar
 * @description top bar navigation element
 */
angular.module('mercury.directives.topbar', [])
.directive('topbar', ["$filter", "multisite", "userinfo", "authService", "$state", "$window", "dialog", "applicationMenu", "$rootScope", "companyChange", "$location", function($filter, multisite, userinfo, authService, $state, $window, dialog, applicationMenu, $rootScope, companyChange, $location) {
  return {
    templateUrl: 'directives/topbar/topbar.tpl.html',
    link: function(scope) {
      scope.sideBarOpen = false;
      scope.username = userinfo.userDetails().firstName + (userinfo.userDetails().lastName ? ' ' + userinfo.userDetails().lastName : '');
      scope.companies = userinfo.companies();
      scope.current = userinfo.activeCompany();

      scope.multisite = multisite.isMultisiteEnabled();

      if (scope.sidenav) {
        scope.showbackbutton = false;
      } else {
        scope.showbackbutton = true;
      }

      scope.loading = applicationMenu.getMenu();
      scope.loading.then(function(companyReports) {
        scope.links = companyReports;
        scope.links = scope.links.map(link => {

          const linkUrlStartPathMatch = link.link.match(/^#(\/[^/]+)/)
          const linkUrlStartPath = linkUrlStartPathMatch ? linkUrlStartPathMatch[1] : ''

          return Object.assign({}, link, {
            active: linkUrlStartPath != '' && $location.path().startsWith(linkUrlStartPath)
          })
        })
      });

      scope.logout = function() {
        authService.clearToken();
        $window.location.assign('/');
      };

      scope.toggleSidebar = function() {
        scope.sideBarOpen = !scope.sideBarOpen;
      };

      scope.goHome = function() {
        $window.location = '/App#/';
      };

      scope.companyClicked = function(company, event) {
        companyChange.changeCompanyAndRefresh(company, event);
      };

      scope.label = function() {
        if (scope.multisite) {
          var enabled = $filter('filter')(scope.companies, function(company) {
            return !multisite.isCompanyDisabled(company.id);
          });

          if (enabled.length === scope.companies.length) {
            return 'All Sites';
          } else if (enabled.length === 1) {
            return userinfo.companyName(enabled[0].id);
          } else {
            return enabled.length + ' Sites';
          }
        }

        if (scope.current) {
          return userinfo.companyName(scope.current);
        }

        return '';
      };

      scope.$on('userInfoUpdated', function() {
        scope.username = userinfo.userDetails().name;

        scope.multisite = multisite.isMultisiteEnabled();
      });

      scope.inviteSupport = function() {
        dialog.open({
          templateUrl: 'modules/settings/support/supportinvites.tpl.html',
          controller: 'SupportInvitesCtrl'
        });
      };

      scope.openCompanySettings = function() {
        $state.go('Settings.CompanyPreferencesReact');
      };

      scope.openIntercom = function() {
        if (window.Intercom) {
          window.Intercom('show');
        }
      }

    }
  };
}]);
